<template>
  <div class="container row g-32 column-mobile">
    <div class="navigation no-flex g-32">
      <slot name="menu"></slot>
    </div>

    <div class="content no-flex">
      <div class="padding">
        <slot></slot>
      </div>

      <slot name="plugins"></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
.navigation {
  width: 300px;
  margin-bottom: 32px;

  @include smd {
    width: 100%;
    margin-bottom: 0;
  }
}

.column-mobile {
  @include smd {
    flex-direction: column-reverse;
  }
}

.container {
  align-items: flex-start;
  padding: 0 48px;

  &:deep(.container) {
    padding: 0 48px;

    @include mobile {
      padding: 0 16px;
    }
  }

  @include mobile {
    padding: 0;
  }
}

.content {
  background: $light-grey;
  width: 820px;
  max-width: 100%;
  padding: 56px 0;
  margin-bottom: 96px;

  @include smd {
    margin-top: 0;
    padding: 25px 0;
    margin-bottom: 0;
  }

  &:deep(.html-content) {
    line-height: 24px;
  }
}

.padding {
  padding: 0 48px;

  @include smd {
    padding: 0 16px;
  }
}

.content:deep(.par) {
  margin-bottom: 10px;
  line-height: 21px;
}


</style>
